import { Button, Card, Col, Flex, Modal, Row, Select, Space } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { ReactComponent as PDFIcon } from "../../../assets/icon/pdfIcon.svg";
import dayjs from 'dayjs'
function EmployeeSalaryDownloadModal({
    isModalDownloadOpen,
    setIsModalDownloadOpen,
    payrollPeriodYear = [],
    payrollPeriodByEmployee = {},
    monthList = [],
    setSelectedMonth,
    filteredPayrollPeriod = () => { },
    getPaySlipReportByPayrollPeriodFile = () => { },
    setSelectedYear = () => { },
    selectedYear = () => { },
    isDownloading = false
}) {
    const { t, i18n } = useTranslation();

    // console.log("ma paaaaaao", payrollPeriodByEmployee);

    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={isModalDownloadOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {i18n.language === "en"
                        ? "For the safety of data files Must enter with the password of the person who has access only."
                        : "เพื่อความปลอดภัยของไฟล์ข้อมูล จะต้องเข้าด้วยรหัสผ่านของผู้มีสิทธิเข้าถึงเท่านั้น"}
                </span>
                <Flex justify="end" gap={10}>
                    <Select
                        key="year"
                        size="large"
                        placeholder={t("unit.year")}
                        style={{ width: "100px" }}
                        options={payrollPeriodYear}
                        value={selectedYear}
                        onChange={(value) => setSelectedYear(value)}
                        allowClear
                        onClear={() => setSelectedYear(null)}
                    />
                    <Select
                        key="month"
                        options={monthList}
                        size="large"
                        placeholder={t("unit.month")}
                        style={{ width: "120px" }}
                        onChange={(value) => setSelectedMonth(value)}
                        allowClear
                        onClear={() => setSelectedMonth(null)}
                    />
                </Flex>
                <Flex vertical style={{ width: "100%", height: "40vh", gap: "16px", overflowY: "scroll" }}>
                    {(Array.isArray(filteredPayrollPeriod) ? filteredPayrollPeriod : [])?.map((data) => (
                        <Card
                            style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                            styles={{ body: { padding: "16px" } }}
                        >
                            <Row style={{ width: "100%" }}>
                                <Col span={16}>
                                    <Flex gap={16} align="center">
                                        <PDFIcon />
                                        <Flex vertical>
                                            <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("payment_period.label.periodAt")} {data?.periodNo} {t("unit.month")} {dayjs(String(data?.month)?.padStart(2, "0"), "MM")?.format("MMMM")}</span>
                                            <span style={{ color: "#42526D" }}>{t("common.pdf_file")}</span>
                                        </Flex>
                                    </Flex>
                                </Col>
                                <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                                    <Button type="default"
                                        style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                        onClick={() => { getPaySlipReportByPayrollPeriodFile(data) }}
                                        loading={!!isDownloading[data?.id]}
                                        disabled={!!isDownloading[data?.id]}
                                        icon={
                                            !isDownloading[data?.id] ? (
                                                <DownloadIcon style={{ fontSize: 16 }} />
                                            ) : (
                                                <span style={{ width: 16, height: 16 }} />
                                            )
                                        }
                                    >
                                        <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    ))}
                </Flex>

                <Row justify={"end"}>
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => { setIsModalDownloadOpen(false) }}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    )
}
export default EmployeeSalaryDownloadModal;